import { UseFormReturn } from 'react-hook-form';
import { SelectField } from '@brighte/form-components';
import { IncomeVerificationType } from '@brighte/validation';
import { INCOME_VERIFICATION, LABELS } from '../../utils';

type RetiredOrPensionerProps = Pick<UseFormReturn<IncomeVerificationType>, 'control'>;

function RetiredOrPensioner({ control }: RetiredOrPensionerProps) {
  const { RETIRED_OR_PENSIONER, PENSION_TYPE } = LABELS;
  const { PENSIONER_OPTIONS } = INCOME_VERIFICATION;

  return (
    <SelectField
      data={{ testid: 'retired-or-pensioner-select' }}
      name="applicant.employment.pensioner.pensionType"
      control={control}
      label={PENSION_TYPE}
      options={PENSIONER_OPTIONS}
      placeholder={RETIRED_OR_PENSIONER}
    />
  );
}

export default RetiredOrPensioner;
